import "./GettingStartedModal.scss";
import Modal from "../../shared/Modal/Modal";
import AssignLicencesInfo from "../../../assets/images/AssignLicencesInfo.png";
import UploadLogoInfo from "../../../assets/images/UploadLogoInfo.png";
import DownloadInfo from "../../../assets/images/DownloadInfo.png";

import { Button } from "@mui/material";
import GettingStarted from "../../shared/SVG/GettingStarted";

export default function GettingStartedModal(props: any) {
  const ModalContent = () => {
    return (
      <div className="getting-started-content p-4 ">
        <div className="getting-started-header">
          Follow these steps to get started with your account:
        </div>
        <ol>
          <div>
            <div className="getting-started-info pt-3">
              <li>
                Assign GPs to the licences you have purchased. Search for GPs in
                your clinic and assign them a licence.
              </li>
              <img className="pt-2 w-100" src={AssignLicencesInfo}></img>
            </div>
          </div>
          <div>
            <div className="getting-started-info pt-3">
              <li>Personalise your account by uploading your clinic logo.</li>
              <img className="pt-2 w-100" src={UploadLogoInfo}></img>
            </div>
          </div>
          <div>
            <div className="getting-started-info pt-3">
              <li>
                Download Inca Evo, and enter your licence key to start using.
              </li>
              <img className="pt-2 w-100" src={DownloadInfo}></img>
            </div>
          </div>
        </ol>
      </div>
    );
  };
  return (
    <Modal
      title="Getting started"
      headerLogo={<GettingStarted color={"white"} />}
      isOpen={props.isOpen}
      children={<ModalContent />}
      onClose={props.onClose}
      closeOnOverLayClick={false}
      headerBg="var(--primary-color)"
      closeIconColor={"var(--white)"}
      modalFooter={
        <div className="d-flex justify-content-between gap-1 getting-started-footer">
          <Button
            className="close-button px-5"
            onClick={() => {
              props.onClose();
            }}
            variant="outlined"
          >
            I'm ready to get started
          </Button>
          <Button
            className="tutorial-button px-5"
            variant="contained"
            onClick={() => {
              window.open(process.env.REACT_APP_TUTORIAL_URL);
            }}
          >
            Watch 30 second tutorial
          </Button>
        </div>
      }
    />
  );
}
